import { useEffect, useState } from "react";

const WHATSAPP_NUMBER = "917012998898";
const PREFILL = encodeURIComponent(
  "Hi Rydey, I'd like to discuss corporate transportation for my company."
);

export default function WhatsAppFloat() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${PREFILL}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat with Rydey on WhatsApp"
      className={`fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_18px_40px_-12px_rgba(37,211,102,0.6)] transition-all duration-300 hover:scale-110 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      style={{ animation: show ? "pulseGold 2.4s ease-out infinite" : "none" }}
    >
      <svg
        viewBox="0 0 32 32"
        className="w-7 h-7 md:w-8 md:h-8 fill-white"
        aria-hidden="true"
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.435 3.41 4.412 4.5.616.343 2.063 1.06 2.766 1.06.687 0 2.18-.4 2.42-1.32.188-.72-.014-1.395-.343-1.65-.502-.4-1.292-.79-1.964-.79zm-2.52 8.245c-2.25 0-4.5-.785-6.347-2.18l-.286-.215-4.63 1.26 1.275-4.59-.215-.286a10.46 10.46 0 0 1-2.106-6.31c0-5.795 4.715-10.51 10.510-10.51 2.808 0 5.45 1.094 7.43 3.075a10.43 10.43 0 0 1 3.08 7.435c0 5.79-4.92 10.32-8.71 10.32zm0-22.76C9.45 2.69 4.21 7.93 4.21 14.32c0 2.066.55 4.075 1.604 5.84L4.04 26.2l6.16-1.617c1.706.945 3.633 1.45 5.59 1.45 6.39 0 11.81-5.42 11.81-11.812 0-3.157-1.232-6.118-3.467-8.357A11.74 11.74 0 0 0 16.59 2.69z" />
      </svg>
    </a>
  );
}
